export const crewRoles = ["driver", "conductor", "driveronly"];

export const matatuSubscriptionTypes = [
  {
    name: "Charge Passenger",
    description: "Transaction fee is charged to the passenger",
    value: "PAGPassenger",
  },
  {
    name: "Charge Matatu",
    description: "Transaction fee is charged the matatu",
    value: "PAGCrew",
  },
];

export const crewMatatuStatus = ["active", "suspended", "inactive"];

export const authorisedPages = [
  "/index.html",
  "/profile.html",
  "/",
  "register.html",
];

/** Populated from `.env` / `.env.local` / deploy-time `.env` (see `.env.example`). */
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? "",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL ?? "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ?? "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID ?? "",
};

export const routeColors = {
  33: "#345496",
  58: "#773db4",
  237: "#0ABE78",
  111: "#426EFF",
  46: "#ef6c00",
  105: "#4e342e",
  "4W": "#455a64",
  119: "#1a237e",
  118: "#b71c1c",
  "17B": "#c43e00",
};

export const userRoles = {
  Admin: "Admin",
  MainBrandAmbassador: "MainBrandAmbassador",
  BrandAmbassador: "BrandAmbassador",
  SaccoSuperAdmin: "SaccoSuperAdmin",
  SaccoAdmin: "SaccoAdmin",
  SaccoStaff: "SaccoStaff",
  SaccoParcelUser: "SaccoParcelUser",
  SaccoParcelAdmin: "SaccoParcelAdmin",
  StageManager: "StageManager",
  StageUser: "StageUser",
};

export const userAccessLevels = {
  ADMIN: "admin",
  WITHDRAWAL: "withdrawal",
  STAFF: "staff",
  BASIC: "basic",
  SACCO_ADMIN: "saccoAdmin",
  SACCO: "sacco",
  SACCO_STAFF: "saccoStaff",
  PARCEL_BASIC: "parcelBasic",
  PARCEL_ADMIN: "parcelAdmin",
  STAGE_MANAGER: "stageManager",
  STAGE_USER: "stageUser",
};

export const userAccessRoles = {
  Admin: { role: userRoles.Admin, levels: [userAccessLevels.ADMIN] },
  MainBrandAmbassador: {
    role: userRoles.MainBrandAmbassador,
    levels: [userAccessLevels.WITHDRAWAL],
  },
  BrandAmbassador: {
    role: userRoles.BrandAmbassador,
    levels: [userAccessLevels.BASIC],
  },
  SaccoSuperAdmin: {
    role: userRoles.SaccoSuperAdmin,
    levels: [userAccessLevels.SACCO_ADMIN],
  },
  SaccoAdmin: {
    role: userRoles.SaccoAdmin,
    levels: [userAccessLevels.WITHDRAWAL, userAccessLevels.SACCO],
  },
  SaccoStaff: {
    role: userRoles.SaccoStaff,
    levels: [userAccessLevels.SACCO_STAFF],
  },
  SaccoParcelUser: {
    role: userRoles.SaccoParcelUser,
    levels: [userAccessLevels.PARCEL_BASIC],
  },
  SaccoParcelAdmin: {
    role: userRoles.SaccoParcelAdmin,
    levels: [userAccessLevels.PARCEL_ADMIN, userAccessLevels.PARCEL_BASIC],
  },
  StageManager: {
    role: userRoles.StageManager,
    levels: [userAccessLevels.STAGE_MANAGER],
  },
  StageUser: {
    role: userRoles.StageUser,
    levels: [userAccessLevels.STAGE_USER],
  },
};
